// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1ogDG","title":"ClientReferral_title__JrfHD","itemText":"ClientReferral_itemText__2rmbP"};